import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching products
export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async () => {
    const response = await fetch('/data/product.json');
    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }
    const data = await response.json();
    return data; // Returns the fetched product data if successful
  }
);

const initialState = {
  items: [],
  status: 'idle',
  error: null,
  sortOrder: 'default',
  priceRange: [80, 700],
  selectedCategories: [],
  selectedColors: [],
  onSale: false,
  inStock: false,
  selectedProduct: null,
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    // Reducer to set sort order based on selected option
    setSortOrder(state, action) {
      state.sortOrder = action.payload;
    },
    // Reducer to reset sort order
    resetSortOrder(state) {
      state.sortOrder = 'Default sorting';
    },
    // Reducer to set the price range for filtering products
    setPriceRange(state, action) {
      state.priceRange = action.payload;
    },
    // Reducer to set selected categories for filtering products
    setSelectedCategories(state, action) {
      state.selectedCategories = action.payload;
    },
    // Reducer to set selected colors for filtering products
    setSelectedColor(state, action) {
      state.selectedColors = action.payload;
    },
    //Reducer to toggle onSale filter
    setOnSale(state, action) {
      state.onSale = action.payload;
    },
    //Reducer to toggle inStock filter
    setInStock(state, action) {
      state.inStock = action.payload;
    },
    // Reducer to reset categories filter
    resetCategories(state) {
      state.selectedCategories = [];
    },
    // Reducer to reset color filter
    resetColors(state) {
      state.selectedColors = [];
    },
    // Reducer to reset all filters to their default
    resetFilters(state) {
      state.priceRange = [80, 700];
      state.selectedCategories = [];
      state.selectedColors = [];
      state.onSale = false;
      state.inStock = false;
      state.sortOrder = 'default';
    },
    // Reducer to set the currently selected product
    setSelectedProduct(state, action) {
      state.selectedProduct = action.payload;
    },
    // Reducer to set the remove selected product
    clearSelectedProduct(state) {
      state.selectedProduct = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = 'loading'; // Set status to loading when the fetch request is pending
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload; // Update the items array with fetched product data
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed'; // Set status to failed if the fetch request fails
        state.error = action.error.message;
      });
  },
});

export const {
  setSortOrder,
  resetSortOrder,
  setSortCriteria,
  setPriceRange,
  setSelectedCategories,
  setSelectedColor,
  setOnSale,
  setInStock,
  resetCategories,
  resetColors,
  resetFilters,
  setSelectedProduct,
  clearSelectedProduct,
} = productSlice.actions;

export default productSlice.reducer;
